import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import clsx from 'clsx';
import InputFocus from '../input-focus/InputFocus';

export default function TableHeaderSearch({
  title,
  searchTerm,
  dataIndex,
  onChange,
  onSubmit,
  onReset,
  toggleDropdown,
  onClose,
  placement = 'bottomRight', // default placement strategy
}) {
  const { t } = useTranslation(['tables', 'forms']);

  const value = useMemo(() => {
    return searchTerm[dataIndex] || '';
  }, [dataIndex, searchTerm]);

  const open = useMemo(() => {
    return toggleDropdown[dataIndex];
  }, [dataIndex, toggleDropdown]);

  const handleEnterSubmit = (e) => {
    if (e.key === 'Enter') {
      onSubmit(dataIndex, searchTerm);
    }
  };

  return (
    <div className="h-max" onKeyDown={handleEnterSubmit}>
      <Dropdown
        placement={placement}
        open={open}
        trigger={['click']}
        onOpenChange={(value) => {
          onClose(dataIndex, !!value);
        }}
        popupRender={() => (
          <div className="grid min-w-[180px] gap-3 rounded-md border-[3px] border-accent bg-white p-3 shadow-md">
            <label htmlFor={dataIndex} className="font-semibold">
              {title}:
            </label>

            <InputFocus
              title={title}
              value={value}
              onChange={onChange}
              dataIndex={dataIndex}
            />

            <div className="flex gap-3">
              <Button
                size="small"
                type="default"
                className="btn-default btn-default--hover h-8 w-1/2"
                onClick={() => onReset(dataIndex)}
              >
                {t('reset', { ns: 'forms' })}
              </Button>

              <Button
                size="small"
                type="primary"
                className="btn-primary h-8 w-1/2"
                onClick={() => onSubmit(dataIndex, searchTerm)}
              >
                {t('submit', { ns: 'forms' })}
              </Button>
            </div>
          </div>
        )}
      >
        <Button
          type="default"
          className={clsx('btn-default h-6 w-6 bg-transparent p-0 shadow-none')}
          icon={
            <SearchOutlined
              className={clsx(
                'rounded-full p-1.5',
                value ? 'bg-white !text-accent shadow-md' : 'text-zinc-400'
              )}
            />
          }
        >
          <span className="sr-only">{t('search', { ns: 'forms' })}</span>
        </Button>
      </Dropdown>
    </div>
  );
}
